import api from "./api";

export interface RequestParams {
  itemIds: Array<number>;
  target: Array<Target>;
  /** 传 true 则移动，不传则复制 */
  deleteOriginalItem?: boolean;
};

export interface Target {
  newFolderId: number;
  newTagIds: Array<number>;
};

// 素材库批量复制/移动标签
export async function materialCopyBatchCopy({
  itemIds,
  target,
  deleteOriginalItem,
}: RequestParams) {
  const res = await api.post('/material_copy/batch_copy', {
    item_ids: itemIds,
    delete_original_item: deleteOriginalItem,
    target: target.map(item => ({
      new_folder_id: item.newFolderId,
      new_tag_ids: item.newTagIds,
    })),
  });
  return res.data;
}
